import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import * as React from 'react';
import { CircularProgress, Button,Typography,Box } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import GameCard from './GameCard';
import {TextField} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSearchParams, useNavigate } from "react-router-dom";


var itemPerPage = 50;

async function loadgamesfromlocalstorage(rom_name,console_id,filter){
  let console_rom = JSON.parse(localStorage.getItem(rom_name)); 
  let game_components = []
  console_rom = console_rom.filter(roms => roms["name"].toLowerCase().includes(filter.toLowerCase()))
  console_rom.sort((a,b) => a["name"].localeCompare(b["name"]))
  for (const roms of console_rom) {
    const card = <GameCard id={roms["id"]} name={roms["name"]} console_id={console_id} />
    game_components.push(card);
  }
  return game_components;
}

function GameList(props) {
  const [game_consoles, setGameConsoles] = React.useState([]);
  const [has_loaded, setHasLoaded] = React.useState(false);
  const [search_filter, setSearchFilter] = React.useState("");
  const [current_page, setCurrentPage] = React.useState(0);
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  console.log(searchParams);
  let filter = "";

  if (searchParams.get("q") !== null){
    filter = searchParams.get("q"); 
  }
  console.log(filter);
  const game_components = [];
  const params = useParams();
  let console_id = params.consoleId;

  let rom_name = "rom" + props.id;
  let console_rom = JSON.parse(localStorage.getItem(rom_name)); 

  if (!has_loaded){
    if (console_rom === null){
      console.log("asking rom for console" + console_id)
      axios.get('https://retrodb.djalim.fr/consoles/'+ console_id + '/roms')
        .then((result) => {
          localStorage.setItem(rom_name,JSON.stringify(result.data));
          result.data = result.data.filter(roms => roms["name"].includes(filter));
          result.data.sort((a,b) => a["name"].localeCompare(b["name"]))
          for (const roms of result.data) {
            const card = <GameCard id={roms["id"]} name={roms["name"]} console_id={console_id} />
            game_components.push(card);
          }
          setGameConsoles(game_components);
          setHasLoaded(true);
        })
    }else{
      console.log("loading roms from cache");
      loadgamesfromlocalstorage(rom_name,props.id,filter).then(game_components =>{
        setGameConsoles(game_components);
        setHasLoaded(true);
      });
    } 
  }


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      setSearchParams({"q" : search_filter});
      navigate(0);
    }
  };

  function NavigationButtons(){
    let len =  (game_consoles.length - (game_consoles.length % itemPerPage)) / itemPerPage;
    console.log(len);

    return (
      <Stack spacing={2} sx={{display:"flex",justifyContent:"center"}}>
        <Pagination count={len} page={current_page} onChange={(event,value)=>setCurrentPage(value)} />
      </Stack>)
  }


  if (!has_loaded){
    return <Box 
      display="flex"
      flexDirection="column"
      justifyContent="center"
      padding="1rem"
    >
      <br/>
      <CircularProgress/>
    </Box>
  }
  else{
    let shown = game_consoles.slice(current_page*itemPerPage,current_page*itemPerPage+itemPerPage) 
    return (
      <Box 
        display="flex"
        flexDirection="column"
        justifyContent="center"
        padding="1rem"
      >
        <TextField id="outlined-basic" label="Rechercher" variant="outlined" onKeyDown={handleKeyDown} sx={{marginBottom:"1rem"}}  onChange={e => setSearchFilter(e.target.value)}  />
        <NavigationButtons/>
        <Typography variant="h4"
          component="div"
          sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' }, textAlign:"center", color:"white" }} >
          Jeux de cette console
        </Typography>
        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent:"space-evenly"}}>
          {shown}
        </div>
        <NavigationButtons/>
      </Box>
    );
  }
}
export default GameList;
